<template lang="pug">
  .res
    .title
    .content
      res-success
    .bottom
      countdown-btn(:countdown="5" copy="回到首页")


  
</template>
<script>
import { mapMutations } from 'vuex'
import ResConfirm from '@/components/res/ResConfirm'
import ResSuccess from '@/components/res/ResSuccess'
import CountdownBtn from '@/components/wedgits/CountdownBtn'
export default {
  name: 'Res5',
  components: { CountdownBtn, ResSuccess, ResConfirm },
  props: {},
  data() {
    return {}
  },

  computed: {},
  methods: {
    ...mapMutations('app', ['setRouterBack', 'setRouterLast', 'setPending']),
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
@import "src/styles/res.sass"
</style>
